import { SVGProps } from "react";

export default function ArrowRightCircleIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 11, width = 30, stroke = "black", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M18.9362 5.33203C18.9362 8.27755 21.324 10.6654 24.2695 10.6654C27.215 10.6654 29.6029 8.27755 29.6029 5.33203C29.6029 2.38651 27.215 -0.00130224 24.2695 -0.00130224C21.324 -0.00130224 18.9362 2.38651 18.9362 5.33203ZM0 5.33203V6.33203H24.2695V5.33203V4.33203H0V5.33203Z"
        fill={stroke}
      />
    </svg>
  );
}
